import React from 'react';

const Footer = () => {
  return (
    <footer className="lil-mt-8">

      <div className="lil-bg-[#0f0013] lil-text-white lil-pt-10 lil-pb-4">
      <div className="lil-max-w-7xl lil-mx-auto lil-px-4">
        
        {/* Newsletter */}
        <div className="lil-flex lil-justify-center lil-items-center lil-gap-8 lil-mb-8">
        <a href="https://www.toulouse.aeroport.fr/" className="lil-flex-1 lil-flex lil-justify-start lil-my-5 lil-mb-8">
            <img
          
          src="https://img-assets.bookfhr.com/logo-white-atbxbdv.jpg"
          alt="Aéroport Toulouse Blagnac"
          className="lil-h-14"
          />
          </a>
        <a href="https://www.enjoytravel.com/" className="lil-flex lil-justify-center lil-items-center lil-my-5 lil-mb-8">
            <img
              src="https://img-assets.bookfhr.com/powered-by-enjoy-white.svg"
              alt="Enjoy Travel Powered by Enjoy"
              className="lil-h-14"
              />
          </a>
              </div>
        {/* <div className="lil-flex lil-flex-col lil-items-center lil-mb-8">
          <span className="lil-text-lg lil-font-semibold lil-mb-2">Pour rester informés, abonnez-vous à notre newsletter :</span>
          <form className="lil-flex lil-gap-2 lil-mt-2">
            <input type="email" placeholder="Votre email" className="lil-px-4 lil-py-2 lil-rounded lil-text-black lil-outline-none" />
            <button type="submit" className="lil-bg-pink-500 lil-text-white lil-px-4 lil-rounded">OK</button>
          </form>
        </div> */}
        {/* Liens principaux */}
        <div className="lil-flex lil-flex-col lil-items-center md:lil-flex-row lil-justify-between md:lil-items-start lil-gap-8 lil-mb-8">
          {/* Liens utiles */}
          <div>
            <ul className="lil-space-y-2">
              {/* <li><a href="https://www.toulouse.aeroport.fr/blog" className="lil-hover:underline">Blog</a></li>
              <li><a href="https://www.toulouse.aeroport.fr/foire-aux-questions" className="lil-hover:underline">FAQ</a></li>
              <li><a href="https://www.toulouse.aeroport.fr/actualites" className="lil-hover:underline">Actualités</a></li>
              <li><a href="https://www.toulouse.aeroport.fr/espace-presse" className="lil-hover:underline">Espace Presse</a></li> */}
              <div className="lil-flex lil-flex-col lil-items-end lil-text-white lil-text-sm"> 
            <span className="lil-flex lil-items-center lil-cursor-pointer" onClick={() => window.location.href = 'tel:0899493212'}>
              <i className="fas fa-phone lil-mr-2 lil-text-md md:lil-text-lg"></i>
              <b className="lil-text-md md:lil-text-lg">08 99 49 32 12</b>
            </span>
            <span className="lil-text-xs">0.80 €/min</span>
          </div>

            </ul>
          </div>
          {/* Mentions légales */}
          <div>
            <ul className="lil-space-y-2">
              <li><a href="https://www.enjoytravel.com/fr/terms-conditions" className="lil-hover:underline">Conditions Générales</a></li>
              <li><a href="https://www.enjoytravel.com/fr/privacy-policy" className="lil-hover:underline">Mentions légales</a></li>
              <li><a className="lil-py-4" href="#" onClick={(e) => { e.preventDefault(); window.Didomi?.preferences?.show(); }}>Editer mes cookies</a></li>
            </ul>
          </div>
          {/* App */}
          <div className="lil-flex lil-flex-col lil-items-center">
            <span className="lil-font-semibold lil-mb-2">Téléchargez l'App</span>
            <div className="lil-flex lil-gap-2">
              <a href="https://play.google.com/store/apps/details?id=fr.toulouse.aeroport.aeroporttls"><img src="https://img-assets.bookfhr.com/GetItOnGooglePlay_Badge_Web_color_French-CA.svg" alt="Google Play" className="lil-h-10" /></a>
              <a href="https://itunes.apple.com/fr/app/toulouse-blagnac-airport-official/id950681000"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" className="lil-h-10" /></a>
            </div>
          </div>
          {/* Réseaux sociaux */}
          <div className="lil-flex lil-flex-col lil-items-center">
            <span className="lil-font-semibold lil-mb-2">Suivez-nous !</span>
            <div className="lil-flex lil-gap-3">
              <a href="https://www.pinterest.fr/AeroportToulouseBlagnac/" aria-label="Pinterest"><i className="fab fa-pinterest lil-text-2xl"></i></a>
              <a href="https://www.instagram.com/aeroporttoulouse/" aria-label="Instagram"><i className="fab fa-instagram lil-text-2xl"></i></a>
              <a href="https://www.facebook.com/AeroportToulouse/" aria-label="Facebook"><i className="fab fa-facebook lil-text-2xl"></i></a>
              <a href="https://www.linkedin.com/company/a%C3%A9roport-toulouse-blagnac/" aria-label="LinkedIn"><i className="fab fa-linkedin lil-text-2xl"></i></a>
              <a href="https://www.youtube.com/user/AeroportToulouse" aria-label="YouTube"><i className="fab fa-youtube lil-text-2xl"></i></a>
              <a href="https://twitter.com/aeroport_tls" aria-label="Twitter"><i className="fab fa-twitter lil-text-2xl"></i></a>
            </div>
          </div>
        </div>
        {/* Bas de page */}
        <div className="lil-text-center lil-text-xs lil-mt-4">© 1989 - 2025 Enjoy Airport Services Ltd. All rights reserved.</div>
      </div>
      </div>
    </footer>
  );
};

export default Footer; 